import type { StateCreator } from 'zustand';
import type { LineageGraph } from '@/domain/lineage/types';
import type { NpcCreature } from '@/domain/npc/types';
import { emptyGraph } from '@/domain/lineage/mutate';
import type { AppStore } from './types';

export interface LineageSliceState {
  lineage: LineageGraph;
  npcs: NpcCreature[];
}

export interface LineageSliceActions {
  setLineage: (g: LineageGraph) => void;
  addNpc: (n: NpcCreature) => void;
  updateNpc: (n: NpcCreature) => void;
  setNpcs: (list: NpcCreature[]) => void;
}

export type LineageSlice = LineageSliceState & LineageSliceActions;

export const createLineageSlice: StateCreator<AppStore, [], [], LineageSlice> = (set) => ({
  lineage: emptyGraph(),
  npcs: [],
  setLineage: (lineage) => {
    set({ lineage });
  },
  addNpc: (n) => {
    set((s) => ({ npcs: [...s.npcs, n] }));
  },
  updateNpc: (n) => {
    set((s) => ({ npcs: s.npcs.map((x) => (x.id === n.id ? n : x)) }));
  },
  setNpcs: (npcs) => {
    set({ npcs });
  },
});
